import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconAMD: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg height={size} width={size} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      fill="#000000"
      fillRule="evenodd"
      d="M5 1a4 4 0 0 0 -4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4 -4V5a4 4 0 0 0 -4 -4H5Zm14.5 3.5h-15l4.09 4.09h6.82v6.82l4.09 4.09v-15Zm-15 9.546 4.09 -4.091v5.454h5.796l-4.09 4.091H4.5v-5.454Z"
      clipRule="evenodd"
      strokeWidth="1"
    />
  </svg>
);

IconAMD.defaultProps = defaultIconProps;
